module.exports = __webpack_public_path__ + "static/media/teo-logo-400px.8f204a07.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/teo-logo-400px.png
// module id = 1860
// module chunks = 0